module.exports = __webpack_public_path__ + "img/voitishin_500.621524e7.jpg";